module.exports = __webpack_public_path__ + "i.no2.5ded61f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/female_to_male/i.no2.jpg
// module id = c+0J
// module chunks = 0